import { useMemo } from 'react';
import StyleSheet from 'react-native-media-query';
import { Text, TextProps } from '@ui-kitten/components';

import customMapping from '../Theme/mapping';
import breakpoints from '../Theme/styles/breakpoints';

// Adjust category mapping as needed
const categoryMapping = {
  // Web: Mobile
  h1: 'h3',
  h2: 'h3',
  h3: 'h3',
  h4: 'h5',
  h5: 'h6',
  h6: 's1',
  s1: 's2',
};
const typeAcronymMapping = {
  h: 'heading',
  s: 'subtitle',
  p: 'paragraph',
  c: 'caption',
};
const getFontSize = (category: string) => {
  const withLevel = category.length === 2;
  const [type, level] = category;
  const mappedCategory = `${withLevel ? typeAcronymMapping[type] : category}${
    level && withLevel ? `-${level}` : ''
  }`;
  const keyByCategory = `text-${mappedCategory}`;
  return customMapping.strict[`${keyByCategory}-font-size`];
};
const makeStyles = (webFontSize: number, mobileFontSize: number) =>
  StyleSheet.create({
    fontSize: {
      fontSize: webFontSize,
      [`@media ${breakpoints.xs}`]: {
        fontSize: mobileFontSize,
      },
    },
  });
const ResponsiveText = ({ category = 'p1', children, ...rest }: TextProps) => {
  const mobileCategory = useMemo(
    () => categoryMapping[category] || category,
    [category],
  );
  const webFontSize = useMemo(() => getFontSize(category), [category]);
  const mobileFontSize = useMemo(
    () => getFontSize(mobileCategory),
    [mobileCategory],
  );
  const { ids, styles } = useMemo(
    () => makeStyles(webFontSize, mobileFontSize),
    [webFontSize, mobileFontSize],
  );
  return (
    <Text
      {...rest}
      category={category}
      dataSet={{ media: ids.fontSize }}
      style={[rest.style, styles.fontSize]}
    >
      {children}
    </Text>
  );
};

export default ResponsiveText;
